function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M37.9982,74.7751 C37.3732,75.0761 36.7012,75.2801 35.9952,75.3721 C36.7152,74.9031 37.2682,74.1601 37.5292,73.2761 C36.8552,73.7101 36.1082,74.0251 35.3142,74.1951 C34.6782,73.4591 33.7712,73.0001 32.7682,73.0001 C30.8422,73.0001 29.2812,74.6951 29.2812,76.7861 C29.2812,77.0831 29.3122,77.3731 29.3712,77.6491 C26.4732,77.4911 23.9032,75.9841 22.1832,73.6931 C21.8832,74.2521 21.7112,74.9021 21.7112,75.5971 C21.7112,76.9101 22.3272,78.0691 23.2622,78.7481 C22.6912,78.7291 22.1532,78.5581 21.6832,78.2741 L21.6832,78.3231 C21.6832,80.1571 22.8852,81.6881 24.4802,82.0361 C24.1872,82.1221 23.8792,82.1681 23.5612,82.1681 C23.3362,82.1681 23.1182,82.1451 22.9052,82.1001 C23.3492,83.6041 24.6372,84.7001 26.1632,84.7301 C24.9692,85.7461 23.4662,86.3521 21.8312,86.3521 C21.5502,86.3521 21.2732,86.3331 21.0002,86.2991 C22.5432,87.3731 24.3762,88.0001 26.3462,88.0001 C32.7602,88.0001 36.2682,82.2301 36.2682,77.2251 C36.2682,77.0611 36.2642,76.8981 36.2582,76.7351 C36.9392,76.2021 37.5312,75.5351 37.9982,74.7751",
  id: "icon_twitter",
  stroke: "none",
  fill: "#ffffff",
  fillRule: "evenodd"
});

function SvgIconTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "21 72 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.4ad4a87a.svg";
export { ForwardRef as ReactComponent };